export const LOGINSTAT = "LOGINSTAT";
export const TOKEN = "TOKEN";

export function pushLoginstat(values) {
  return {
    type: LOGINSTAT,
    payload: values
  };
}

export function pushToken(values) {
  return {
    type: TOKEN,
    payload: values
  };
}
